export default __webpack_public_path__ + "static/media/newrelicDark.beb7ae36.svg";